import React from 'react';

interface NotificationPreferencesProps {
  configValues: Record<string, string>;
  onChange: (key: string, val: string) => void;
  onSave: () => void;
  saving?: boolean;
  loading?: boolean;
}

const NotificationPreferences: React.FC<NotificationPreferencesProps> = ({ configValues, onChange, onSave, saving, loading }) => {
  const notificationItems = [
    {
      id: 'notifications.email',
      label: 'Email Notifications',
      desc: 'Send booking confirmations and updates via email',
      icon: '✉️',
      accent: 'hsl(215,90%,57%)',
    },
    {
      id: 'notifications.sms',
      label: 'SMS Notifications',
      desc: 'Send OTP and critical alerts via SMS',
      icon: '💬',
      accent: 'hsl(162,72%,47%)',
    },
    {
      id: 'notifications.push',
      label: 'Push Notifications',
      desc: 'Real-time alerts for mobile app users',
      icon: '🔔',
      accent: 'hsl(262,67%,62%)',
    },
  ];

  return (
    <div style={{
      background: 'hsl(var(--card))',
      padding: 24,
      borderRadius: 16,
      border: '1px solid hsl(var(--border))',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '20px' }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'hsl(var(--foreground))' }}>
          Notification Preferences
        </h3>
      </div>
      
      {loading ? (
        <div style={{ color: 'hsl(var(--muted-foreground))', fontSize: 14 }}>Loading configuration...</div>
      ) : (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
            {notificationItems.map((item) => {
              const on = configValues[item.id] !== 'false'; // default true if not strictly 'false'
              return (
                <div key={item.id} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '14px 16px', borderRadius: 12,
                  border: `1px solid ${on ? item.accent + '40' : 'hsl(var(--border))'}`,
                  background: on ? item.accent + '08' : 'hsl(var(--muted)/0.4)',
                  transition: '0.2s',
                }}>
                  <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <div style={{
                      width: 40, height: 40, borderRadius: 10,
                      background: on ? item.accent + '18' : 'hsl(var(--muted))',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
                    }}>
                      {item.icon}
                    </div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: 'hsl(var(--foreground))' }}>{item.label}</div>
                      <div style={{ fontSize: 12, color: 'hsl(var(--muted-foreground))', marginTop: 2 }}>{item.desc}</div>
                    </div>
                  </div>
                  <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: 'pointer', flexShrink: 0 }}>
                    <input
                      type="checkbox"
                      checked={on}
                      onChange={() => onChange(item.id, (!on).toString())}
                      style={{ opacity: 0, width: 0, height: 0 }}
                    />
                    <span style={{
                      position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
                      backgroundColor: on ? item.accent : 'hsl(var(--border))',
                      transition: '.3s', borderRadius: 34,
                    }}>
                      <span style={{
                        position: 'absolute', height: 18, width: 18,
                        left: on ? '23px' : '3px', bottom: 3,
                        backgroundColor: 'white', transition: '.3s', borderRadius: '50%',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      }} />
                    </span>
                  </label>
                </div>
              );
            })}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button 
              onClick={onSave} 
              disabled={saving} 
              style={{ padding: "10px 20px", borderRadius: "10px", border: "none", background: "hsl(var(--primary))", color: "#fff", fontWeight: "600", cursor: "pointer" }}>
              {saving ? 'Saving...' : '✓ Save Settings'}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationPreferences;